module.exports = __webpack_public_path__ + "static/oredugba-767bcd1fb7fcbfe97801b2a5afb73251.png";